<template>
  <AbstractModalHeader :title="title">
    <template #prepend-item>
      <CloseIconButton @click="$emit('close')"></CloseIconButton>
    </template>
    <template #append-item>
      <div class="ml-2">
        <slot />
      </div>
    </template>
    <template #close v-if="!isManager">
      <BaseTextButton @click="$emit('openSettlementColumn')">
        <img class="mr-2" src="../../../../../public/img/settlement-icon.svg" alt="ikona rozliczenia" />
        Rozliczenie
      </BaseTextButton>
    </template>
  </AbstractModalHeader>
</template>

<script>
import AbstractModalHeader from '@/component/Dialog/abstract-modal-header';
import CloseIconButton from '@/component/Button/close-icon-button';
import BaseTextButton from '@/component/Base/base-text-button';
import { mapGetters } from 'vuex';

export default {
  name: 'AbstractCourseHeader',
  components: {
    AbstractModalHeader,
    CloseIconButton,
    BaseTextButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isManager']),
  },
};
</script>

<style lang="scss" scoped></style>
